import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'widget-line-anim',
  templateUrl: './widget-line-anim.component.html',
  styleUrls: ['./widget-line-anim.component.scss']
})
export class WidgetLineAnimComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }

}
